export default __webpack_public_path__ + "static/media/input-by-subcategory.d2e4e1a6.svg";